










import { Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { DoCreateComplaintFirstStepFormData } from "@/interfaces/falcon/do-create-complaint/do-create-complaint-first-step-form-data";
import { DoCreateComplaintSecondStepFormData } from "@/interfaces/falcon/do-create-complaint/do-create-complaint-second-step-form-data";
import { DoCreateComplaintFalconRequest } from "@/interfaces/falcon/do-create-complaint/do-create-complaint-falcon-request";

import { RouterPathName } from "@/enums/router-path-name.enum";
import { FalconComplaintState } from "@/enums/falcon/complaints/falcon-complaint-state.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint creation summary
 */
@Component({
  filters: {
    ...capitalizeFilter
  }
})
export default class ComplaintCreationSummary extends Vue {
  @State(state => state.falconComplaints.complaintFormData.details)
  private detailsFormData!: DoCreateComplaintFirstStepFormData;
  @State(state => state.falconComplaints.complaintFormData.vehicle)
  private vehicleFormData!: DoCreateComplaintSecondStepFormData;
  @State(state => state.falconComplaints.complaintFormData.defectDescription)
  private complaintDefectDescription!: string;
  @Action("falconComplaints/createComplaint")
  private createComplaint!: (request: DoCreateComplaintFalconRequest) => void;

  @Watch("$route", { immediate: true }) private routeUpdated(): void {
    const { documentId, itemId, productId } = this.$route.params;
    this.documentId = documentId;
    this.itemId = itemId;
    this.productId = productId;
  }

  private documentId = "";
  private itemId = "";
  private productId = "";
  private storeSub!: () => void;

  i18nMessageKeyEnum = I18nMessageKey;

  created(): void {
    this.storeSub = this.$store.subscribe(mutation => {
      if (mutation.type === "falconComplaints/complaintCreated") {
        this.$router.push({
          name: RouterPathName.FalconComplaintsView,
          query: {
            complaintState: FalconComplaintState.Terminal.toString()
          }
        });
      }
    });
  }

  beforeDestroy(): void {
    // Unsubscribe Vuex store.
    // https://vuex.vuejs.org/api/#subscribe
    this.storeSub();
  }

  complaintCreationRequested(): void {
    this.createComplaint({
      doCreateComplaint: {
        complaintInfo: {
          srcDocumentId: this.documentId,
          srcItemId: this.itemId,
          productId: this.productId,
          ...this.detailsFormData,
          ...this.vehicleFormData,
          defectDescription: this.complaintDefectDescription
        }
      }
    });
  }
}
